var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "div",
    {
      staticClass: "cw-shelf-dialog-import-wrapper",
    },
    [
      !_vm.importRunning
        ? _c("studip-wizard-dialog", {
            attrs: {
              title: _vm.$gettext("Lernmaterial importieren"),
              confirmText: _vm.$gettext("Importieren"),
              closeText: _vm.$gettext("Abbrechen"),
              slots: _vm.wizardSlots,
              lastRequiredSlotId: 1,
              requirements: _vm.requirements,
            },
            on: {
              close: function close($event) {
                return _vm.setShowUnitImportDialog(false)
              },
              confirm: _vm.importCoursewareArchiv,
            },
            scopedSlots: _vm._u(
              [
                {
                  key: "file",
                  fn: function fn() {
                    var _vm$importZipFile

                    return [
                      _c(
                        "form",
                        {
                          staticClass: "default",
                          on: {
                            submit: function submit($event) {
                              $event.preventDefault()
                            },
                          },
                        },
                        [
                          _c("label", [
                            _c("span", [_vm._v(_vm._s(_vm.text.import))]),
                            _c(
                              "span",
                              {
                                staticClass: "wizard-required",
                                attrs: {
                                  "aria-hidden": "true",
                                },
                              },
                              [_vm._v("*")]
                            ),
                            _vm._v(" "),
                            _c("input", {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: _vm.importZipFile === null,
                                  expression: "importZipFile === null",
                                },
                              ],
                              ref: "fileInput",
                              staticClass: "cw-file-input",
                              attrs: {
                                type: "file",
                                accept: ".zip",
                              },
                              on: {
                                change: _vm.setImport,
                              },
                            }),
                            _vm._v(" "),
                            _c(
                              "p",
                              {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value: _vm.importZipFile !== null,
                                    expression: "importZipFile !== null",
                                  },
                                ],
                                staticClass: "cw-file-input-change",
                              },
                              [
                                _c(
                                  "button",
                                  {
                                    staticClass: "button",
                                    on: {
                                      click: function click($event) {
                                        return _vm.$refs.fileInput.click()
                                      },
                                    },
                                  },
                                  [_vm._v(_vm._s(_vm.$gettext("Datei ändern")))]
                                ),
                                _c("span", [
                                  _vm._v(
                                    _vm._s(
                                      (_vm$importZipFile =
                                        _vm.importZipFile) === null ||
                                        _vm$importZipFile === void 0
                                        ? void 0
                                        : _vm$importZipFile.name
                                    )
                                  ),
                                ]),
                              ]
                            ),
                          ]),
                          _vm._v(" "),
                          _c(
                            "fieldset",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: _vm.archiveErrors.length > 0,
                                  expression: "archiveErrors.length > 0",
                                },
                              ],
                            },
                            [
                              _c("legend", [
                                _vm._v(
                                  _vm._s(
                                    _vm.$gettext("Fehler im Import-Archiv")
                                  )
                                ),
                              ]),
                              _vm._v(" "),
                              _c(
                                "ul",
                                _vm._l(
                                  _vm.archiveErrors,
                                  function (error, index) {
                                    return _c(
                                      "li",
                                      {
                                        key: index,
                                      },
                                      [_vm._v(" " + _vm._s(error) + " ")]
                                    )
                                  }
                                ),
                                0
                              ),
                            ]
                          ),
                        ]
                      ),
                    ]
                  },
                  proxy: true,
                },
                {
                  key: "edit",
                  fn: function fn() {
                    return [
                      _vm.hasValidFile
                        ? _c(
                            "form",
                            {
                              staticClass: "default",
                              on: {
                                submit: function submit($event) {
                                  $event.preventDefault()
                                },
                              },
                            },
                            [
                              _c("label", [
                                _vm._v(
                                  "\n                    " +
                                    _vm._s(_vm.text.title) +
                                    "\n                    "
                                ),
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.modifiedData.title,
                                      expression: "modifiedData.title",
                                    },
                                  ],
                                  attrs: {
                                    type: "text",
                                    placeholder: _vm.loadedTitle,
                                    required: "",
                                  },
                                  domProps: {
                                    value: _vm.modifiedData.title,
                                  },
                                  on: {
                                    input: function input($event) {
                                      if ($event.target.composing) {
                                        return
                                      }

                                      _vm.$set(
                                        _vm.modifiedData,
                                        "title",
                                        $event.target.value
                                      )
                                    },
                                  },
                                }),
                              ]),
                              _vm._v(" "),
                              _c(
                                "label",
                                [
                                  _vm._v(
                                    "\n                    " +
                                      _vm._s(_vm.text.color) +
                                      "\n                    "
                                  ),
                                  _c("studip-select", {
                                    attrs: {
                                      options: _vm.colors,
                                      reduce: function reduce(color) {
                                        return color.class
                                      },
                                      clearable: false,
                                      label: "class",
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "open-indicator",
                                          fn: function fn(selectAttributes) {
                                            return [
                                              _c(
                                                "span",
                                                _vm._b(
                                                  {},
                                                  "span",
                                                  selectAttributes,
                                                  false
                                                ),
                                                [
                                                  _c("studip-icon", {
                                                    attrs: {
                                                      shape: "arr_1down",
                                                      size: "10",
                                                    },
                                                  }),
                                                ],
                                                1
                                              ),
                                            ]
                                          },
                                        },
                                        {
                                          key: "no-options",
                                          fn: function fn() {
                                            return [
                                              _vm._v(
                                                "\n                            " +
                                                  _vm._s(
                                                    _vm.$gettext(
                                                      "Es steht keine Auswahl zur Verfügung."
                                                    )
                                                  ) +
                                                  "\n                        "
                                              ),
                                            ]
                                          },
                                          proxy: true,
                                        },
                                        {
                                          key: "selected-option",
                                          fn: function fn(_ref) {
                                            var name = _ref.name,
                                              hex = _ref.hex
                                            return [
                                              _c("span", {
                                                staticClass: "vs__option-color",
                                                style: {
                                                  "background-color": hex,
                                                },
                                              }),
                                              _c("span", [
                                                _vm._v(_vm._s(name)),
                                              ]),
                                            ]
                                          },
                                        },
                                        {
                                          key: "option",
                                          fn: function fn(_ref2) {
                                            var name = _ref2.name,
                                              hex = _ref2.hex
                                            return [
                                              _c("span", {
                                                staticClass: "vs__option-color",
                                                style: {
                                                  "background-color": hex,
                                                },
                                              }),
                                              _c("span", [
                                                _vm._v(_vm._s(name)),
                                              ]),
                                            ]
                                          },
                                        },
                                      ],
                                      null,
                                      false,
                                      630196857
                                    ),
                                    model: {
                                      value: _vm.modifiedData.color,
                                      callback: function callback($$v) {
                                        _vm.$set(_vm.modifiedData, "color", $$v)
                                      },
                                      expression: "modifiedData.color",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c("label", [
                                _vm._v(
                                  "\n                    " +
                                    _vm._s(_vm.text.description) +
                                    "\n                    "
                                ),
                                _c("textarea", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.modifiedData.description,
                                      expression: "modifiedData.description",
                                    },
                                  ],
                                  attrs: {
                                    placeholder: _vm.loadedDescription,
                                    required: "",
                                  },
                                  domProps: {
                                    value: _vm.modifiedData.description,
                                  },
                                  on: {
                                    input: function input($event) {
                                      if ($event.target.composing) {
                                        return
                                      }

                                      _vm.$set(
                                        _vm.modifiedData,
                                        "description",
                                        $event.target.value
                                      )
                                    },
                                  },
                                }),
                              ]),
                            ]
                          )
                        : _c("courseware-companion-box", {
                            attrs: {
                              msgCompanion: _vm.$gettext(
                                "Bitte wählen Sie ein Import-Archiv aus."
                              ),
                              mood: "unsure",
                            },
                          }),
                    ]
                  },
                  proxy: true,
                },
              ],
              null,
              false,
              2111857058
            ),
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.importRunning
        ? _c("studip-dialog", {
            attrs: {
              title: _vm.$gettext("Lernmaterial importieren"),
              closeText: _vm.$gettext("Schließen"),
              height: "420",
            },
            on: {
              close: function close($event) {
                return _vm.setShowUnitImportDialog(false)
              },
            },
            scopedSlots: _vm._u(
              [
                {
                  key: "dialogContent",
                  fn: function fn() {
                    return [
                      _c(
                        "div",
                        {
                          attrs: {
                            role: "status",
                            "aria-live": "polite",
                          },
                        },
                        [
                          _c("courseware-companion-box", {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value:
                                  _vm.importDone &&
                                  _vm.importErrors.length === 0,
                                expression:
                                  "importDone && importErrors.length === 0",
                              },
                            ],
                            attrs: {
                              msgCompanion: _vm.$gettext("Import erfolgreich!"),
                              mood: "special",
                            },
                          }),
                          _vm._v(" "),
                          _c("courseware-companion-box", {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value:
                                  _vm.importDone && _vm.importErrors.length > 0,
                                expression:
                                  "importDone && importErrors.length > 0",
                              },
                            ],
                            attrs: {
                              msgCompanion: _vm.$gettext(
                                "Import abgeschlossen. Es sind Fehler aufgetreten!"
                              ),
                              mood: "unsure",
                            },
                          }),
                          _vm._v(" "),
                          _c("courseware-companion-box", {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: !_vm.importDone,
                                expression: "!importDone",
                              },
                            ],
                            attrs: {
                              msgCompanion: _vm.$gettext(
                                "Import läuft. Bitte schließen Sie den Dialog nicht bis der Import abgeschlossen wurde."
                              ),
                              mood: "pointing",
                            },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      !_vm.importDone
                        ? _c(
                            "form",
                            {
                              staticClass: "default",
                              on: {
                                submit: function submit($event) {
                                  $event.preventDefault()
                                },
                              },
                            },
                            [
                              _c("fieldset", [
                                !_vm.fileImportDone
                                  ? _c(
                                      "div",
                                      {
                                        staticClass: "cw-import-zip",
                                      },
                                      [
                                        _c("header", [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$gettext("Importiere Dateien")
                                            ) + ":"
                                          ),
                                        ]),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          {
                                            staticClass: "progress-bar-wrapper",
                                          },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticClass: "progress-bar",
                                                style: {
                                                  width:
                                                    _vm.importFilesProgress +
                                                    "%",
                                                },
                                                attrs: {
                                                  role: "progressbar",
                                                  "aria-valuenow":
                                                    _vm.importFilesProgress,
                                                  "aria-valuemin": "0",
                                                  "aria-valuemax": "100",
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.importFilesProgress
                                                  ) + "%"
                                                ),
                                              ]
                                            ),
                                          ]
                                        ),
                                        _vm._v(
                                          "\n                        " +
                                            _vm._s(_vm.importFilesState) +
                                            "\n                    "
                                        ),
                                      ]
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm.fileImportDone
                                  ? _c(
                                      "div",
                                      {
                                        staticClass: "cw-import-zip",
                                      },
                                      [
                                        _c("header", [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$gettext(
                                                "Importiere Elemente"
                                              )
                                            ) + ":"
                                          ),
                                        ]),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          {
                                            staticClass: "progress-bar-wrapper",
                                          },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticClass: "progress-bar",
                                                style: {
                                                  width:
                                                    _vm.importStructuresProgress +
                                                    "%",
                                                },
                                                attrs: {
                                                  role: "progressbar",
                                                  "aria-valuenow":
                                                    _vm.importStructuresProgress,
                                                  "aria-valuemin": "0",
                                                  "aria-valuemax": "100",
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.importStructuresProgress
                                                  ) + "%"
                                                ),
                                              ]
                                            ),
                                          ]
                                        ),
                                        _vm._v(
                                          "\n                        " +
                                            _vm._s(_vm.importStructuresState) +
                                            "\n                    "
                                        ),
                                      ]
                                    )
                                  : _vm._e(),
                              ]),
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.importErrors.length > 0
                        ? _c(
                            "form",
                            {
                              staticClass: "default",
                              on: {
                                submit: function submit($event) {
                                  $event.preventDefault()
                                },
                              },
                            },
                            [
                              _c("fieldset", [
                                _c("legend", [
                                  _vm._v(
                                    _vm._s(_vm.$gettext("Fehlermeldungen"))
                                  ),
                                ]),
                                _vm._v(" "),
                                _c(
                                  "ul",
                                  _vm._l(
                                    _vm.importErrors,
                                    function (error, index) {
                                      return _c(
                                        "li",
                                        {
                                          key: index,
                                        },
                                        [_vm._v(" " + _vm._s(error) + " ")]
                                      )
                                    }
                                  ),
                                  0
                                ),
                              ]),
                            ]
                          )
                        : _vm._e(),
                    ]
                  },
                  proxy: true,
                },
              ],
              null,
              false,
              540449559
            ),
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }